module.exports = __webpack_public_path__ + "img/ppt.4d7478f0.svg";